<onsip-logo-upload [hasDialog]="true" (logoChange)="dialogResponse($event)"> </onsip-logo-upload>
